export default __webpack_public_path__ + "static/media/TOTVS.1e86f84e.png";